import React from 'react';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { Container } from "../common/Container/styled";
import { HeaderBar } from "../common/HeaderBar";
import { Footer } from "../common/Footer";
import { JiraIssues} from '../features/JiraIssues';
import { Dashboard } from '../features/Dashboard';
import { AuthWrapper } from '../features/AuthWrapper';
import { LoginForm } from '../features/AuthWrapper/LoginForm';
import { ResetPasswordForm } from '../features/AuthWrapper/ResetPasswordForm.js/index.js';

export const App = () => {

  return (
    <Container>
      <Router>
        <HeaderBar />
        <Routes>
          <Route path="/" element={<Dashboard />}/>
          <Route path="/:databaseId" element={<Dashboard />} />
          <Route path="/auth/Jira" element={<AuthWrapper />} />
          <Route path="/jira-issue" element={<JiraIssues />} />
          <Route path="/loginForm" element={<LoginForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm/>} />
          <Route path="/check-email" element={<AuthWrapper/>} />
        </Routes>
        <Footer />
      </Router>
    </Container>
  );
};
